import { Component, OnInit, ViewEncapsulation, AfterViewInit, NgZone, ViewContainerRef, ViewChild, ElementRef, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { AuthService, IUserInfo, MessageBrokerService, ErrorModel } from './shared/core/index';
import { ProjectItem } from './project/index';
import { AppService } from './app.service';
import { NotificationsService, Notification } from './shared/helper-components/index'
import { Observable } from 'rxjs/Observable';
import { ActivatedRoute, Router } from '@angular/router';
import * as $ from 'jquery';
import { SharedUtils } from './shared/utils';
import { GlobalErrorHandler } from './shared/core/error-handler';
import { HttpErrorModel } from './shared/core/error.model';
import { ModalPromptComponent } from './shared/helper-components/modal-prompt.component';
import jwt_decode from 'jwt-decode';
import { map } from 'rxjs/operators';
import { Http } from '@angular/http';
import { URLSearchParams } from '@angular/http';
import { FileUploader, FileItem } from 'ng2-file-upload';
import { IHelpDocsReference } from './project/project.model';

/**
 * App Component
 * Top Level Component
 */


@Component({
  selector: 'app',
  encapsulation: ViewEncapsulation.None,
  styles: [
    require('./app.component.css'), require('../../node_modules/animate.css/animate.min.css')
  ],
  template: require('./app.component.html')
})
export class AppComponent implements OnInit, AfterViewInit {
  appUserInfo: IUserInfo = new IUserInfo();
  favoriteProjects: ProjectItem[] = [];
  recentProjects: ProjectItem[] = [];
  isProjectPrefLoading: boolean;
  term = new FormControl();
  searchResults: Array<ProjectItem>;
  currentProjectName: string;
  isClearanceUser: boolean;
  isProductionUser: boolean;
  errorLoadingProjects: boolean;
  autocompleteInit = {};
  viewContainerRef: ViewContainerRef;
  private openedProject: ProjectItem;
  defaultErrorMessage: string = 'Apologies, something went wrong, please mention the following error/code when requesting help: ';
  environment = '';
  @ViewChild('appMainSection') appMainSection: ElementRef;
  helpReferenceDocuments : IHelpDocsReference[] = [];
  @ViewChild('documentInput') documentInput: ElementRef;
  public uploader: FileUploader = new FileUploader({ disableMultipart: true });
  downloadInProcess: boolean = false;
  downloadTooltip: string = "";

  constructor(
    private _authService: AuthService,
    private _appService: AppService,
    private ngZone: NgZone,
    private _notificationsService: NotificationsService,
    private _messageBrokerService: MessageBrokerService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _http: Http,
    viewContainerRef: ViewContainerRef,
    private _errorHandler: GlobalErrorHandler

  ) {
    this.viewContainerRef = viewContainerRef;
    this.environment = _authService.ENV ? _authService.ENV : this.environment;
  }

  public ngOnInit() {  
    console.log('Start Main Component');
       
    if (typeof this._authService.userInfo.accessToken !== 'undefined'){
      var redirection = localStorage.getItem('redirectUrl');
      if(redirection)
      {
        localStorage.removeItem('redirectUrl');
        this._router.navigateByUrl(redirection);        
      }
      if (this._authService.userInfo != null && this._authService.userInfo.accessToken) {      
        this.appUserInfo = this._authService.userInfo;
        this.refreshLeftNav();
        this.ProcessSearch();
        this.subScribeProjectNameChanges();
        this.subScribeProjecDeleted();
        this.isClearanceUser = this._authService.isUserInRole(process.env.CLEARANCE_ROLE) || process.env.ENV == 'development';
        this.isProductionUser = !this._authService.isUserInRole(process.env.CLEARANCE_ROLE)
        this.subScribeRefreshLeftNav();
      }
      else {
        // console.error('AppComponent.ngOnInit(): ' + JSON.stringify(this._authService.accessDetails + ', ' + this._authService.error));
        //Show Message to Refresh the complete application.

        if(this._authService.error !== null){
          let error: ErrorModel = new ErrorModel();
          error.reloadRoute = '/';
          error.shouldRefreshApp = true;

        
          if (this._authService.error) {
            var httpError: HttpErrorModel;
            //try to parse it to an http err response (they come in json array)
            let err = this._authService.error.json();
            if (err instanceof Array && err.length > 0) {
              httpError = err[0];
              error.httpError = <HttpErrorModel>httpError;
            }
            else {
              Object.assign(error, err);
            }
          }
          //let's override any api message for a generic one
          error.Message = this.defaultErrorMessage;
          this._messageBrokerService.showErrorScreen(error);
        }
      }
    }
    this.verifyHtmlCanvas();  
    this.initUploader();
    this._appService.downloadingObservable.subscribe((downloading) => {
      this.activateDownloadTooltip(downloading);
    })
  }

  activateDownloadTooltip(downloading){
    this.downloadInProcess = downloading;
    this.downloadTooltip =  `Downloading. ${this._appService.downloadFileNames.length} pending file(s)` ;
    if (downloading){
      var e = $('#downloadNotificationItem');
      e[0].attributes.getNamedItem('data-tooltip').value = this.downloadTooltip;
      e.tooltip();
    }
  }

  toCustomUser(r: any): IUserInfo {

    try {

       let obj = JSON.parse(r);

        var roles: String[] = new Array<String>();
        let userInfo = <IUserInfo>
            ({
                userId: obj.userId,
                userName: obj.userName,
                name: obj.name,
                organizationId: obj.organizationId,
                organizationName: obj.organizationName,
                role: obj.role,
                photoUrl: obj.photoUrl,
                phone: obj.phone,
                email: obj.email,
                accessToken:obj.accessToken
            });
            
        return userInfo;

    } catch (ex) {
        console.log('could not find roles on current user, exception: >>>' + ex);
    }
  }
 
  ngAfterViewInit() {

    $(".button-collapse").sideNav({ closeOnClick: SharedUtils.IsMobile() ? true : false });
    $('.modal').modal();
    SharedUtils.RemoveTooltipIfNeeded();

    this.runLeftNavJQuery();
  }
  verifyHtmlCanvas(){
    if (!HTMLCanvasElement.prototype.toBlob) {
        Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
          value: function (callback, type, quality) {
            var canvas = this;
            setTimeout(function() {
      
              var binStr = atob( canvas.toDataURL(type, quality).split(',')[1] ),
                  len = binStr.length,
                  arr = new Uint8Array(len);
      
              for (var i = 0; i < len; i++ ) {
                arr[i] = binStr.charCodeAt(i);
              }
      
              callback( new Blob( [arr], {type: type || 'image/png'} ) );
      
            });
          }
        });
      }
  }
  goToItemList(sortByField: string): void {

    if (!sortByField)
      sortByField = 'ModifiedDate';

    this._router.navigate(
      [
        'projects',
        this.openedProject ? this.openedProject.ProjectId : 'undefined',
        'items'
      ],
      { queryParams: { sortBy: sortByField, sortOrder: 'DESC' , projectName: this.openedProject.ProjectName} });
  }
  goToReports(): void {
    //commented the following since it's not needed anymore (re: SCR-300)
    // if (this.isProjectSelected()){
    this._router.navigate(['reports']);
    // }else{
    //   this._notificationsService.add(new Notification('info', 'Please select a project first for reports',''));      
    // }
  }
  openProjcts():void{
    alert('dsaf');
  }
  ProcessSearch(): void {
    // console.log('ProcessSearch()...running');
    this._appService.search(this.term.valueChanges)
      .subscribe(searchResults => {
        
        this.searchResults = searchResults;
        if (searchResults != null && searchResults.length > 0) {

          //console.log(searchResults);
          var projNames: string = '';
          for (let proj of searchResults) {
            projNames += JSON.stringify(proj.ProjectName)  + ": null,";
          }
          projNames = '{' + projNames.slice(0, -1) + '}';
          var data = JSON.parse(projNames);

          this.autocompleteInit = {
            'data': data,
            onAutocomplete: (val) => {
              console.warn('selected project...at' + Date.now() + ':' + val)
              this.selectSearchedProject(val);
              this.term.setValue(''); //clear value, per SCR-447
            },
          };
        }
      }, err => {
        if (err.status != 404) {
          this._errorHandler.processError(err);
        }
      });
  }
  selectSearchedProject(val: any): void {
    
    console.log('AppComponent.selectSearchedProject() >> selectedProject:' + JSON.stringify(selectedProject));
    if (this.searchResults != null && this.searchResults.length > 0 && val) {
      var selectedProject = this.searchResults.find(it => it.ProjectName == val);
      if (selectedProject != null && selectedProject.ProjectId) {
        this._router.navigateByUrl('/dashboard/' + selectedProject.ProjectId);
      }
    }
    console.log('selectSearchedProject(val: any) >> ' + val);
  }
  subScribeProjectNameChanges(): void {

    let self = this;
    this._messageBrokerService.getCurrentProject().subscribe((project: ProjectItem) => {
      // console.log('AppComponent.subScribeProjectNameChanges() >> project:' + JSON.stringify(project));
      if (project != null) {
        self.currentProjectName = project.ProjectName;
        self.openedProject = project;
        //add it to the recent only if it's a real project (when adding, this block can be called)
        if (project.ProjectId) {
          self.addProjectToRecentList(project);
        }
      }else{
        self.openedProject = null;
        self.currentProjectName = '';
      }
      this._appService.isProjectLoaded = true;
      this.getHelpReferenceDocuments();
    });
  }

  subScribeProjecDeleted(): void {
    let self = this;
    this._messageBrokerService.getDeletedProject().subscribe((projectId: string) => {
      console.log('AppComponent.subScribeProjecDeleted() >> projectId:' + projectId);
      if (projectId) {
        if (self.recentProjects && self.recentProjects.length > 0) {
          var index = self.recentProjects.findIndex(it => it.ProjectId == projectId);
          self.recentProjects.splice(index, 1);
        }
        else{
          console.warn('AppComponent.subScribeProjecDeleted() >> No recent projects were found');
        }

        if (self.favoriteProjects && self.favoriteProjects.length > 0) {
          var index = self.favoriteProjects.findIndex(it => it.ProjectId == projectId);
          self.favoriteProjects.splice(index, 1);
        }else{
          console.warn('AppComponent.subScribeProjecDeleted() >> No favorite projects were found');
        }
      }
    });
  }

  subScribeRefreshLeftNav(): void {
    this._messageBrokerService.subscribeRefreshLeftNav().subscribe((projectId: string) => {
      console.log('AppComponent.subScribeRefreshLeftNav() >> projectId:' + projectId);      
      this.refreshLeftNav();
    });
  }
  runLeftNavJQuery(): void {
    this.ngZone.onMicrotaskEmpty.first().subscribe(() => {
      $('.dropdown-button').dropdown({
        inDuration: 300,
        outDuration: 225,
        constrainWidth: false, // Does not change width of dropdown to that of the activator
        hover: false, // Activate on hover
        gutter: 0, // Spacing from edge
        belowOrigin: true, // Displays dropdown below the button
        alignment: 'right', // Displays dropdown with edge aligned to the left of button
        stopPropagation: false // Stops event propagation
      });
      $('.project-more-actions').dropdown({
        inDuration: 10,
        outDuration: 10,
        constrainWidth: false, // Does not change width of dropdown to that of the activator
        hover: false, // Activate on hover
        gutter: 0, // Spacing from edge
        belowOrigin: true, // Displays dropdown below the button
        alignment: 'right', // Displays dropdown with edge aligned to the left of button
        stopPropagation: true // Stops event propagation
      });
      $('.mobile-action-button').dropdown({
        inDuration: 10,
        outDuration: 10,
        constrainWidth: false, // Does not change width of dropdown to that of the activator
        hover: false, // Activate on hover
        gutter: 0, // Spacing from edge
        belowOrigin: true, // Displays dropdown below the button
        alignment: 'left', // Displays dropdown with edge aligned to the left of button
        stopPropagation: true // Stops event propagation
      });
      $('.help-reference-menu').dropdown({
        inDuration: 10,
        outDuration: 10,
        constrainWidth: false, // Does not change width of dropdown to that of the activator
        hover: true, // Activate on hover
        gutter: 0, // Spacing from edge
        belowOrigin: true, // Displays dropdown below the button
        alignment: 'left', // Displays dropdown with edge aligned to the left of button
        stopPropagation: true // Stops event propagation
      });
      $('.help-reference-menuM').dropdown({
        inDuration: 10,
        outDuration: 10,
        constrainWidth: false, // Does not change width of dropdown to that of the activator
        hover: true, // Activate on hover
        gutter: 0, // Spacing from edge
        belowOrigin: true, // Displays dropdown below the button
        alignment: 'right', // Displays dropdown with edge aligned to the left of button
        stopPropagation: true // Stops event propagation
      });
    });
  }

  openProjOptions(proj): void {
    this.openedProject = proj;
    $('.project-more-actions').dropdown('close');
  }
  isAddToFavDisabled(): boolean {
    if (this.openedProject != null && this.favoriteProjects != null && this.favoriteProjects.findIndex(it => it.ProjectId == this.openedProject.ProjectId) >= 0) {
      return true;

    }
    return false;
  }
  isProjectSelected(): boolean {
    return this.openedProject != null && this.openedProject.ProjectId != null && this.openedProject.ProjectId.trim() != '';
  }
  addProjectToFavList(): void {
    if (this.openedProject != null) {
      if (this.isAddToFavDisabled()) {
        return;
      }
      this.isProjectPrefLoading = true;
      this._appService.addFavorite(this.openedProject)
        .subscribe(status => {
          if (status) {
            this.refreshLeftNav();
            this._notificationsService.add(new Notification('success', this.openedProject.ProjectName + ' added to favorites'));
          }
          else {
            this._notificationsService.add(new Notification('error', 'Failed to add ' + this.openedProject.ProjectName + ' to favorites'));
          }

        },
        err => {
          this.isProjectPrefLoading = false;
          this._errorHandler.processError(err);
        });
    }
  }

  removeFromFavList(): void {
    if (this.openedProject != null) {
      this.isProjectPrefLoading = true;
      this._appService.deleteFavorite(this.openedProject)
        .subscribe(status => {
          if (status) {
            this.refreshLeftNav();
            this._notificationsService.add(new Notification('success', this.openedProject.ProjectName + ' removed from favorites'));
          }
          else {
            this._notificationsService.add(new Notification('error', 'Failed to remove ' + this.openedProject.ProjectName + ' from favorites'));
          }

        },
        err => {
          this.isProjectPrefLoading = false;
          this._errorHandler.processError(err);
        });
    }
  }
  
  addProjectToRecentList(project: ProjectItem): void {
    if (!this.isProjectPrefLoading && !this.errorLoadingProjects) {
      var proj = new ProjectItem();
      proj.ProjectId = project.ProjectId;
      proj.ProjectName = project.ProjectName;
      proj.TotalCICount = project.TotalCICount;
      proj.NewCICount = project.NewCICount;
      proj.UserId = this._authService.userInfo.userId;
      proj.SortOrder = 1;
      if (!this.recentProjects)
        this.recentProjects = [];
      if (this.recentProjects.length == 0) {
        this.recentProjects.push(proj);
      }
      else {
        //remove item if there is already exist
        var existingItemIndx = this.recentProjects.findIndex(it => it.ProjectId == project.ProjectId);
        if (existingItemIndx >= 0) {
          this.recentProjects.splice(existingItemIndx, 1);
        }
        //insert item at the starting of list
        this.recentProjects.splice(0, 0, proj);
        
        //just keep only top 2 items in array
        if (this.recentProjects.length > 2)
          this.recentProjects.splice(2, this.recentProjects.length - 2);
        this.runLeftNavJQuery();
      }
    }
  }
  refreshLeftNav(): void {
    
    if (this._authService.accessDetails.access_token) {
      this.isProjectPrefLoading = true;
      this.errorLoadingProjects = false;
      this._appService.getUserPreferences()
        .subscribe(projects => {
          //console.log('AppComponent.refreshLeftNav().this._appService.getUserPreferences() >> projects ' + JSON.stringify(projects) );
          if (projects != null) {
            let fav = projects.filter(p => p.PreferenceType == 'Favorite Project');
            this.favoriteProjects = fav.sort((a, b) => {
              return (a.ProjectName.toLowerCase() > b.ProjectName.toLowerCase() ? 1 : (a.ProjectName.toLowerCase() < b.ProjectName.toLowerCase() ? -1 : 0));
            });

            this.recentProjects = projects.filter(p => p.PreferenceType == 'Recent Project');
            if (this.recentProjects.length > 0){
              this._messageBrokerService.setCurrentProject(this.recentProjects[0]);
            }
          }

          this.isProjectPrefLoading = false;
          this.runLeftNavJQuery();
        },
        err => {
          this.isProjectPrefLoading = false;
          this.errorLoadingProjects = err.status != 404;
          this.runLeftNavJQuery();
          if (err.status != 404) {
            this._errorHandler.processError(err);
          }
        }
        );
    }
  }

  activeRoute(routename: string): boolean {
    //console.log('this._router.url:' + this._router.url + ', routename:' + routename);
    return this._router.url.indexOf(routename) > -1;
  }

  onMainSectionScroll() {
    const mainElement = this.appMainSection.nativeElement;
    const scrollTop = mainElement.scrollTop;
    const elementHeight = mainElement.clientHeight;
    const scrollHeight = mainElement.scrollHeight;
    var isMainScrollAtBottom = Math.ceil((scrollTop + elementHeight)/10)*10 >= Math.floor(scrollHeight/10)*10;
    if (isMainScrollAtBottom){
      this._appService.scrollBottomReachedEvent.emit();
    }
  }

  openHelpReferenceDocument(event): void {
    var fileExtension = event.path.substring(event.path.lastIndexOf('.'));
    if (event.name.endsWith(fileExtension))
      fileExtension = '';
    const filename = encodeURIComponent(event.name + fileExtension);
    this._appService.getSignedUrlInline(event.path,'Generic','GET','ref','ref',filename)
      .subscribe(signedUrl => {
        event.url = signedUrl.url;
        window.open(event.url);
      });
  }

  uploadHelpReferenceDocument(event): void {
    this.documentInput.nativeElement.click();
    this.documentInput.nativeElement.dataset.docRefId = event.id;
  }

  deleteHelpReferenceDocument(event): void {
    const docRefId = event.id;
    const projectId = this.openedProject ? this.openedProject.ProjectId : 'Generic';
    this._appService.getSignedUrl(encodeURIComponent(event.path), projectId, 'DELETE', 'ref', 'delete', docRefId).subscribe
            (signedUrl => {
              this.getHelpReferenceDocuments();
              this._notificationsService.add(new Notification('success', event.name + ' was removed'));
            },
            (error: any)=>{
              this.getHelpReferenceDocuments();
              this._notificationsService.add(new Notification('error', 'Failed to remove ' + event.name));
            });
  }

  newHelpReferenceDocument(): void {
    this.documentInput.nativeElement.click();
    this.documentInput.nativeElement.dataset.docRefId = 'new';
  }


  getHelpReferenceDocuments() {
    this.helpReferenceDocuments = [];
    const projectId = this.openedProject ? this.openedProject.ProjectId : 'Generic';
    this._appService.getReferenceDocuments(projectId)
        .subscribe(documents => {
          if (documents != null) {
            this.helpReferenceDocuments = documents.map(doc => {
              const helpDoc: IHelpDocsReference = {
                id: doc.HelpDocsReferenceId,
                name: doc.Name,
                path: doc.Path,
                isDefault: doc.IsDefault,
                toolTipDelay: doc.Name.length > 15 ? 500 : 5000,
                toolTipDelayM: doc.Name.length > 15 ? 500 : 5000
              }
              return helpDoc;
            });
          }
        },
        err => {
          if (err.status != 404) {
            this._errorHandler.processError(err);
          }
        }
        );
  }

  initUploader() {
    let self = this;
    // console.log('ClearanceItemAssetManagerComponent.initUploader >> this.assetType:' + this.assetType);// + ', assetType: '+ assetType);

    this.uploader.onBeforeUploadItem = (fileItem) => {
      console.log('initUploader');
    };

    this.uploader.onAfterAddingFile = (fileItem) => {
      fileItem.withCredentials = false;
      this.getSignedUrlToUpload(fileItem, this.documentInput.nativeElement.dataset.docRefId);
    };

    this.uploader.onErrorItem = (fileItem, response, status, headers) => {
      self.uploader.removeFromQueue(fileItem);
      this._notificationsService.add(new Notification('error', 'Failed to upload ' + fileItem.file.name));
      console.error('onErrorItem, file: ' + fileItem.file.name + ', response: ' + response)
    }

    this.uploader.onSuccessItem = (fileItem, response, status, headers) => {
      this.getHelpReferenceDocuments();
      this._notificationsService.add(new Notification('success', fileItem.file.name + ' successfully uploaded'));
      console.log('onSuccessItem, file: ' + fileItem.file.name + ', response: ' + response)
    }


  }

  getSignedUrlToUpload(fileItem, docRefId){
    let self = this;
    const projectId = this.openedProject ? this.openedProject.ProjectId : 'Generic';
    this._appService.getSignedUrl(encodeURIComponent(fileItem.file.name), projectId, 'PUT', 'ref', 'ref', docRefId).subscribe
            (signedUrl => {
                fileItem.file.name = fileItem.file.name;
                fileItem.url = signedUrl.url.toString()
                fileItem.method = "PUT";
                let fileToUpload = this.uploader.queue.find(f => f.file.name == fileItem.file.name);
                if (!fileToUpload) {
                    return;
                }
              self.uploader.uploadItem(fileToUpload);
            });
  }

  setToolTipDelay(){
    const list = document.getElementById('dropdownReferenceDocuments');
    if (list) {
      const docs = list.querySelectorAll('li a.subMenuDownloadLink');
      const docsArray = Array.from(docs);
      docsArray.forEach((link: HTMLAnchorElement) => {
        let doc = this.helpReferenceDocuments.find(d => d.name == link.innerText);
        if (doc){
          doc.toolTipDelay = 500;
          if (!(link.scrollWidth > link.clientWidth)){
            doc.toolTipDelay = 5000;
          }
        }
      });
    }

    const listM = document.getElementById('dropdownReferenceDocumentsM');
    if (listM) {
      const docsM = listM.querySelectorAll('li a.subMenuDownloadLinkM');
      const docsArrayM = Array.from(docsM);
      docsArrayM.forEach((link: HTMLAnchorElement) => {
        let doc = this.helpReferenceDocuments.find(d => d.name == link.innerText);
        if (doc){
          doc.toolTipDelayM = 500;
          if (!(link.scrollWidth > link.clientWidth)){
            doc.toolTipDelayM = 5000;
          }
        }
      });
    }
  }

 
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/app.component.ts